import { ALERT_STATUS } from '~/lib/constants/providerDashboard.constants';
import urlConstants from '~/lib/constants/url.constants';
import {
  ProviderAlert,
  UpdateAlertStatusRequest,
} from '~/lib/types/providerDashboard';
import { HttpRequestMethod } from '~/store';
import { CacheTag } from '~/store/services/CacheTag';

import api from './api';

export const providerDashboardV2Api = api.injectEndpoints({
  endpoints: (build) => ({
    getProviderAlerts: build.query<ProviderAlert[], { providerId: string }>({
      providesTags: [CacheTag.ProviderDashboardV2],
      query: ({ providerId }) => ({
        url: urlConstants.providerDashboard.getAlerts(providerId),
      }),
    }),
    updateAlertStatus: build.mutation<void, UpdateAlertStatusRequest>({
      invalidatesTags: [CacheTag.ProviderDashboardV2],
      query: ({
        providerId,
        alertId,
        status,
        dismissReason,
        dismissDetails,
      }) => ({
        method: HttpRequestMethod.PUT,
        url: urlConstants.providerDashboard.updateAlertStatus(
          providerId,
          alertId,
        ),
        params: { status },
        body:
          status === ALERT_STATUS.DISMISSED
            ? { dismissReason, dismissDetails }
            : undefined,
      }),
    }),
  }),
});

export const { useGetProviderAlertsQuery, useUpdateAlertStatusMutation } =
  providerDashboardV2Api;
